
export enum PJLSNameEnum {
    Plan = "Plan", 
    Job = "Job", 
    Location = "Location",
    Service = "Service",
  }
  